<template>
    <div class="p-5">
        <div class="w-auto">

            <div class="mb-5">
                <h4 class="mb-3">Qualification de la campagne</h4>
                <v-radio-group
                  v-model="configType"
                  row
                  class="d-flex"
                >
                    <v-radio
                      label="Adhésion"
                      value="0"
                    ></v-radio>
                    <v-radio
                      label="Partenariat"
                      value="1"
                    ></v-radio>
                </v-radio-group>
            </div>

            <div class="mb-5">
                <h4 class="mb-3">Titre du formulaire</h4>
                <v-text-field
                  outlined
                  v-model="configTitle"
                  hide-details
                ></v-text-field>
            </div>

            <div class="mb-5">
                <h4 class="mb-3">Texte d'introduction du formulaire</h4>
                <ckeditor
                  :editor="editor"
                  v-model="configIntro"
                ></ckeditor>
            </div>

            <div class="mb-5">
                <h4 class="mb-3">Texte de remerciement</h4>
                <ckeditor
                  :editor="editor"
                  v-model="configThanks"
                ></ckeditor>
            </div>

            <v-expansion-panels>
                <v-expansion-panel style="background-color: #f5f5f5;">
                    <v-expansion-panel-header>
                        <div class="table-title">
                            Offres
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="mb-5">
                            <h4 class="mb-3">Titre section</h4>
                            <v-text-field
                              outlined
                              v-model="configOfferTitle"
                              hide-details
                            ></v-text-field>
                        </div>

                        <div class="mb-5">
                            <h4 class="mb-3">Texte aide 1</h4>
                            <ckeditor
                              :editor="editor"
                              v-model="configOfferHelp1"
                            ></ckeditor>
                        </div>

                        <div class="mb-5">
                            <h4 class="mb-3">Texte aide 2</h4>
                            <ckeditor
                              :editor="editor"
                              v-model="configOfferHelp2"
                            ></ckeditor>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel style="background-color: #f5f5f5;">
                    <v-expansion-panel-header>
                        <div class="table-title">
                            Options
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="mb-5">
                            <h4 class="mb-3">Titre section</h4>
                            <v-text-field
                              outlined
                              v-model="configOptionTitle"
                              hide-details
                            ></v-text-field>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel style="background-color: #f5f5f5;">
                    <v-expansion-panel-header>
                        <div class="table-title">
                            Champ extra
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="mb-5">
                            <h4 class="mb-3">Texte champ extra</h4>
                            <ckeditor
                              :editor="editor"
                              v-model="configExtra"
                            ></ckeditor>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import ClassicEditor from "../../../../plugins/ckeditor"

export default {
    name: "PersonalizeForm",
    data() {
        return {
            editor: ClassicEditor,
            canWatch: false,
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setParameterCurrentStep", "setType", "setFormTitle", "setTxtIntro",
            "setThanksTxt", "setExtraMsg", "setOfferTitle", "setOfferHelp1", "setOfferHelp2", "setOptionTitle"]),
        updateType() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "global_partenariat",
                "value": this.type,
            }

            this.updateKey(payload)
        },
        updateFormTitle() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "titre_general",
                "value": this.formTitle,
            }

            this.updateKey(payload)
        },
        updateTxtIntro() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "introduction",
                "value": this.txtIntro,
            }

            this.updateKey(payload)
        },
        updateThanksText() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "remerciement_1",
                "value": this.thanksText,
            }

            this.updateKey(payload)
        },
        updateExtraMsg() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "extra_field_title",
                "value": this.extraMsg,
            }

            this.updateKey(payload)
        },
        updateOfferTitle() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "offres_titre_complement",
                "value": this.offerTitle,
            }

            this.updateKey(payload)
        },
        updateOfferHelp1() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "offres_aide_1",
                "value": this.offerHelp1,
            }

            this.updateKey(payload)
        },
        updateOfferHelp2() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "offres_aide_2",
                "value": this.offerHelp2,
            }

            this.updateKey(payload)
        },
        updateOptionTitle() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "options_titre_complement",
                "value": this.optionTitle,
            }

            this.updateKey(payload)
        },
        updateKey(payload) {
            this.$global.loading = true

            this.$store.dispatch("cadhConfig/updateConfigurationKey", payload)

            this.$global.loading = false
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "parameterCurrentStep", "type", "formTitle", "txtIntro", "thanksText",
            "extraMsg", "offerTitle", "offerHelp1", "offerHelp2", "optionTitle"]),
        configType: {
            get() {
                return this.type
            },
            set(value) {
                this.setType(value)
            },
        },
        configTitle: {
            get() {
                return this.formTitle
            },
            set(value) {
                this.setFormTitle(value)
            },
        },
        configIntro: {
            get() {
                if (this.txtIntro) {
                    return this.txtIntro
                } else {
                    return ""
                }
            },
            set(value) {
                this.setTxtIntro(value)
            },
        },
        configThanks: {
            get() {
                if (this.thanksText) {
                    return this.thanksText
                } else {
                    return ""
                }
            },
            set(value) {
                this.setThanksTxt(value)
            },
        },
        configExtra: {
            get() {
                if (this.extraMsg) {
                    return this.extraMsg
                } else {
                    return ""
                }
            },
            set(value) {
                this.setExtraMsg(value)
            },
        },
        configOfferTitle: {
            get() {
                if (this.offerTitle) {
                    return this.offerTitle
                } else {
                    return ""
                }
            },
            set(value) {
                this.setOfferTitle(value)
            },
        },
        configOfferHelp1: {
            get() {
                if (this.offerHelp1) {
                    return this.offerHelp1
                } else {
                    return ""
                }
            },
            set(value) {
                this.setOfferHelp1(value)
            },
        },
        configOfferHelp2: {
            get() {
                if (this.offerHelp2) {
                    return this.offerHelp2
                } else {
                    return ""
                }
            },
            set(value) {
                this.setOfferHelp2(value)
            },
        },
        configOptionTitle: {
            get() {
                if (this.optionTitle) {
                    return this.optionTitle
                } else {
                    return ""
                }
            },
            set(value) {
                this.setOptionTitle(value)
            },
        },
    },
    watch: {
        type() {
            if (this.canWatch) {
                this.updateType()
            }
        },
        formTitle() {
            if (this.canWatch) {
                this.updateFormTitle()
            }
        },
        txtIntro() {
            if (this.canWatch) {
                this.updateTxtIntro()
            }
        },
        thanksText() {
            if (this.canWatch) {
                this.updateThanksText()
            }
        },
        extraMsg() {
            if (this.canWatch) {
                this.updateExtraMsg()
            }
        },
        offerTitle() {
            if (this.canWatch) {
                this.updateOfferTitle()
            }
        },
        offerHelp1() {
            if (this.canWatch) {
                this.updateOfferHelp1()
            }
        },
        offerHelp2() {
            if (this.canWatch) {
                this.updateOfferHelp2()
            }
        },
        optionTitle() {
            if (this.canWatch) {
                this.updateOptionTitle()
            }
        },
    },
    updated() {
        this.canWatch = true
    },
}
</script>
